import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import {
  requestPhaseItems,
} from 'actionCreators/phase_items';
import ContractorLaborTable from './contractorLaborTable';
import LaborSheetType from 'types/laborSheet';
import getContractorLineItemsWithTotal from '../../../../../../../../selectors/contractorLineItem';
import S from './laborTables.scss';
import { CUT_POINT } from 'config/constants';

const ContractorLaborTables = (props) => {
  const { lineItems, phaseId, refreshLineItemList, employableType, lineItemId,
          appointmentStartDate, filterLineItems } = props;
  let singleLineItem;
  if (lineItemId !== null) singleLineItem = lineItems.filter(i => i.id >= 0 && i.id === lineItemId);
  const newLineItems = lineItemId !== null ? singleLineItem : lineItems;
  const mappedLineItems = newLineItems.map((laborSheet, index) => <ContractorLaborTable
    key={laborSheet.id}
    laborSheet={laborSheet}
    employableType={employableType}
    phaseId={phaseId}
    refreshList={refreshLineItemList}
    index={index + 1}
    appointmentStartDate={appointmentStartDate}
    filterLineItems={filterLineItems}
  />);
  return (<MediaQuery minWidth={CUT_POINT}>
    {matches => (matches ? (<tr>
      <td className={S.tdIndention} />
      <td className={S.tdIndention} colSpan={'7'}>{mappedLineItems}</td>
    </tr>) : (<tr>
      <td colSpan={'8'}>{mappedLineItems}</td>
    </tr>))}
  </MediaQuery>);
};

ContractorLaborTables.defaultProps = { lineItems: [], filterLineItems: false };

ContractorLaborTables.propTypes = {
  lineItemId: PropTypes.number,
  appointmentStartDate: PropTypes.string,
  phaseId: PropTypes.string,
  lineItems: PropTypes.arrayOf(LaborSheetType),
  employableType: PropTypes.string,
  requestPhaseItems: PropTypes.func,
  refreshLineItemList: PropTypes.func.isRequired,
  filterLineItems: PropTypes.bool,
};

export default connect(state => ({
  lineItems: getContractorLineItemsWithTotal(state),
}), { requestPhaseItems })(ContractorLaborTables);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/contractorLaborTables.jsx